export const hasPurchaseAccount = () => {
	try {
		const user = JSON.parse(sessionStorage.getItem("User")).userdata;
		return !!user.user_id && user.username !== "not-registered";
	} catch (e) {
		return false;
	}
};

export const isPurchasePath = (path) => typeof path === "string"
	&& /^\/(buy-qrCode|flowers|memorial-activate)\/?$/i.test(path);

export const requirePurchaseAccount = () => {
	if (hasPurchaseAccount()) return true;
	window.dispatchEvent(new Event("purchase-access-required"));
	return false;
};
